module.exports = __webpack_public_path__ + "img/icon_point2-9.6ab7654b.svg";